import SchoolsPartnersView from "./SchoolsPartnersView";

export default SchoolsPartnersView;
